import { Component } from 'react';

import store from './appStore/store';

import './App.css';
import './poncho.css';

import Main from './components/Main';

/*
  URLs de referencia:
  https://appdividend.com/2018/11/11/react-crud-example-mern-stack-tutorial/
  https://scalac.io/user-authentication-keycloak-1/
  https://vikaspogu.dev/posts/redhat-sso-react/
  https://medium.com/@cagline/authenticate-and-authorize-react-routes-component-with-keycloak-666e85662636
*/

import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import persistStore from 'reduxjs-toolkit-persist/es/persistStore';
import { PersistGate } from 'reduxjs-toolkit-persist/integration/react';
import ScrollToTop from './components/CompUtils/ScrollToTop';
import HistoryListener from './components/HistoryListener';

let persistor = persistStore(store);
class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
            <ScrollToTop />
            <HistoryListener>
              <Main />
            </HistoryListener>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    );
  }
}

export default App;
